"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _controls = _interopRequireDefault(require("./controls"));

var _table = _interopRequireDefault(require("./table"));

var _pagination = _interopRequireDefault(require("./pagination"));

var _useDebounce = _interopRequireDefault(require("../hooks/useDebounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DataTable = function DataTable(_ref, ref) {
  var columns = _ref.columns,
      rows = _ref.rows,
      tableClass = _ref.tableClass,
      onHeaderClick = _ref.onHeaderClick,
      noRowsMessage = _ref.noRowsMessage,
      columnsConfig = _ref.columnsConfig,
      rowsStyle = _ref.rowsStyle,
      locale = _ref.locale,
      tableWrapperClass = _ref.tableWrapperClass,
      controls = _ref.controls,
      updateTable = _ref.updateTable,
      initialPage = _ref.initialPage,
      totalRows = _ref.totalRows,
      onPagination = _ref.onPagination;

  var _React$useState = _react["default"].useState('10'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      size = _React$useState2[0],
      setSize = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(initialPage || 1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      page = _React$useState4[0],
      setPage = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      search = _React$useState6[0],
      setSearch = _React$useState6[1];

  var debouncedSearch = (0, _useDebounce["default"])(search, 300);
  /** ******************************** */

  /** Pagination bois */

  /** ******************************** */

  var pages = _react["default"].useMemo(function () {
    var pagesNumber = Math.ceil(totalRows / size);
    var pages = [];

    for (var i = page - 3; i <= page + 3; i++) {
      if (i > 0 && i <= pagesNumber) {
        pages.push(i);
      }
    }

    if (pagesNumber && pagesNumber < page) {
      setPage(1);
    }

    return pages;
  }, [page, totalRows, size]);

  _react["default"].useEffect(function () {
    onPagination({
      size: size,
      page: page,
      search: debouncedSearch
    });
  }, [size, page, debouncedSearch, onPagination]);
  /** ******************************** */

  /** Functions */

  /** ******************************** */


  function handlePageChange(value) {
    var newPage = value;

    if (value === 'prev') {
      newPage = page - 1;
    } else if (value === 'next') {
      newPage = page + 1;
    }

    setPage(newPage);
  }

  _react["default"].useImperativeHandle(ref, function () {
    return {
      forceUpdate: function forceUpdate() {
        onPagination({
          size: size,
          page: page,
          search: debouncedSearch
        });
      }
    };
  });

  return _react["default"].createElement("div", {
    className: "wafotable ".concat(tableWrapperClass)
  }, _react["default"].createElement(_controls["default"], {
    locale: locale,
    search: search,
    onSearchChange: function onSearchChange(_ref2) {
      var value = _ref2.target.value;
      return setSearch(value);
    },
    updateTable: updateTable ? function () {
      return updateTable({
        size: size,
        page: page,
        search: search
      });
    } : function () {
      return onPagination({
        size: size,
        page: page,
        search: search
      });
    }
  }, controls), _react["default"].createElement(_table["default"], {
    columns: columns,
    rows: rows,
    tableClass: tableClass,
    onHeaderClick: onHeaderClick,
    noRowsMessage: noRowsMessage,
    columnsConfig: columnsConfig,
    rowsStyle: rowsStyle
  }), rows.length > 0 && _react["default"].createElement(_pagination["default"], {
    locale: locale,
    page: page,
    size: size,
    pages: pages,
    rowsLength: totalRows,
    onPageChange: handlePageChange,
    onSizeChange: function onSizeChange(_ref3) {
      var value = _ref3.target.value;
      return setSize(value);
    }
  }));
};

DataTable.propTypes = {
  // Table props
  columns: _propTypes["default"].array,
  rows: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    data: _propTypes["default"].any,
    config: _propTypes["default"].any
  }), _propTypes["default"].any]),
  tableClass: _propTypes["default"].string,
  onHeaderClick: _propTypes["default"].func,
  noRowsMessage: _propTypes["default"].string,
  columnsConfig: _propTypes["default"].any,
  rowsStyle: _propTypes["default"].any,
  locale: _propTypes["default"].string,
  // DataTable props
  tableWrapperClass: _propTypes["default"].string,
  controls: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  updateTable: _propTypes["default"].func,
  initialPage: _propTypes["default"].number,
  totalRows: _propTypes["default"].number,
  onPagination: _propTypes["default"].func
};
DataTable.defaultProps = {
  // Table props
  columns: [],
  rows: [],
  tableClass: 'table',
  onHeaderClick: null,
  noRowsMessage: '',
  columnsConfig: {},
  rowsStyle: {},
  locale: 'en',
  // LocalTable props
  tableWrapperClass: 'table-wrapper',
  controls: null,
  updateTable: null,
  initialPage: 1,
  totalRows: 0,
  onPagination: function onPagination(f) {
    return f;
  }
};

var _default = (0, _react.forwardRef)(DataTable); // export default DataTable;


exports["default"] = _default;